//angular modules
//DSS Documentation on Angular - http://tiny.sc/cgangular
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

//soco modules
import { SocoUIThemeModule } from '@soco/ui-theme';

//components
//DSS Documentation on Angular Components - http://tiny.sc/cgangularcomponent
import { HomeComponent } from './home.component';

const MODULE_DIRECTIVES = [
    HomeComponent
];

@NgModule({
    imports: [
        //angular modules
        BrowserModule,
        RouterModule,

        //soco modules
        SocoUIThemeModule
    ],
    exports: MODULE_DIRECTIVES,
    declarations: MODULE_DIRECTIVES
})
export class HomeModule { }

